import { ContentContainer, PageHeader, Stage } from "components/layout";
import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { AccountSettings } from "./account-settings/account-settings";
import { AgencySettings } from "./agency-settings/agency-settings";
import { AgencySettingsWorkflow } from "./agency-settings/agency-settings-workflow";
import { ManageIntegrations } from "./manage-integrations/manage-integrations";
import { ManageUsers } from "./manage-users/manage-users";
import { RegionSettings } from "./region-settings/region-settings";
import { TemplatesIndex } from "./templates/templates";

export const ManageRoot: React.FC<unknown> = () => {
    return (
        <Stage>
            <PageHeader title="Settings" />
            <ContentContainer className="bg-zinc-50 m-0! rounded-lg p-4! min-h-screen">
                <Switch>
                    <Route path="/settings/account" component={AccountSettings} />
                    <Route path="/settings/templates" component={TemplatesIndex} />
                    <Route path="/settings/agency" component={AgencySettings} />
                    <Route path="/settings/region" component={RegionSettings} />
                    <Route
                        exact
                        path="/settings/workflow"
                        component={AgencySettingsWorkflow}
                    />
                    <Route
                        exact
                        path="/settings/workflow/:workflowId"
                        component={AgencySettingsWorkflow}
                    />
                    <Route path="/settings/users" component={ManageUsers} />
                    <Route path="/settings/integrations" component={ManageIntegrations} />

                    <Route
                        path="/settings/exports"
                        render={props => (
                            <Redirect
                                to={props.location.pathname.replace("/settings/", "/")}
                            />
                        )}
                    />
                    <Route
                        path="/settings"
                        render={() => <Redirect to="/settings/account" />}
                    />
                </Switch>
            </ContentContainer>
        </Stage>
    );
};
